import './assets/styles/tailwind.css'

import type {App} from 'vue'
import {QueryClient, VueQueryPlugin} from '@tanstack/vue-query'
import PrimeVue from 'primevue/config'
import {Select} from 'primevue'
import BlockCardImages from '@/features/block-card-images/BlockCardImages.vue'
import BlockContactForm from '@/features/block-contact-form/BlockContactForm.vue'
import BaseCollapse from '@/common/components/base/BaseCollapse/BaseCollapse.vue'
import Navigation from '@/features/navigation/Navigation.vue'
import BaseInputDropdown from "@/common/components/base/BaseInputDropdown/BaseInputDropdown.vue";
import BlockTable from '@/features/block-table/BlockTable.vue'
import BlockFaqExtended from '@/features/block-faq-extended/BlockFaqExtended.vue'

export const Components = {
  BlockCardImages,
  BlockContactForm,
  BaseCollapse,
  Navigation,
  BaseInputDropdown,
  BlockTable,
  BlockFaqExtended,
}

export * as Vue from 'vue'
export { renderToString } from 'vue/server-renderer'

export const configureApp = (app: App) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5000,
      },
    },
  })
  app.use(VueQueryPlugin, { queryClient })

  app.use(PrimeVue, {
    unstyled: true,
    ptOptions: {
      mergeSections: true,
      mergeProps: false,
    },
  })
  app.component('PVSelect', Select)
}
